<template>
	<table class="v-table" :width="width" :height="height">
		<thead class="v-table-head">
      <th class="v-table-select" width="30" v-if="checkbox">
        <v-checkbox ref="all"/>
      </th>
			<th v-for="({header,attrs},index) in columns" :key="index" :width="attrs.width">
        <compoennt :is="header(Object.assign(attrs,{index}))" v-if="header"/>
        <div v-else>{{attrs.label}}</div>
			</th>
		</thead>
		<tbody class="v-table-body">
			<tr class="v-table-row" :class="{active:isSelected(row)}" v-for="(row,rowIndex) in data" :key="rowIndex" @click="select(row)">
        <td class="v-table-select" v-if="checkbox">
          <v-checkbox v-model="selected" :value="row" :select-key="checkbox.componentOptions.propsData.selectKey" ref="items"/>
        </td>
        <v-table-column v-for="({$,column},columnIndex) in columns" :key="columnIndex">
          <compoennt :is="$({row,rowIndex,columnIndex})" v-if="$"/>
          <div v-else>{{column(row)}}</div>
        </v-table-column>
			</tr>
		</tbody>
	</table>
</template>

<script>
export default {
  props: {
    data: {
      default() {
        return [];
      }
    },
    width: {
      default: "100%"
    },
    height: {
      default: null
    }
  },
  data() {
    return {
      selected: []
    };
  },
  computed: {
    radio() {
      return this.$slots.default.filter(
        ({ componentOptions = {} }) => componentOptions.tag == "v-table-radio"
      )[0];
    },
    checkbox() {
      return this.$slots.default.filter(
        ({ componentOptions = {} }) =>
          componentOptions.tag == "v-table-checkbox"
      )[0];
    },
    columns() {
      return this.$slots.default
        .filter(
          ({ componentOptions = {} }) =>
            componentOptions.tag == "v-table-column"
        )
        .map(o => {
          let { attrs, scopedSlots = {} } = o.data,
            { value, prop, filter } = attrs;
          return {
            attrs,
            column: row => {
              value = "prop" in attrs ? row[attrs.prop] : value;
              if (filter instanceof Array) {
                return this.$filter[filter[0]].apply(
                  this,
                  [value].concat(filter.slice(1))
                );
              } else {
                return value;
              }
            },
            $:
              "default" in scopedSlots &&
              (def => ({ render: () => scopedSlots.default(def) })),
            header:
              "header" in scopedSlots &&
              (def => ({ render: () => scopedSlots.header(def) }))
          };
        });
    }
  },
  methods: {
    isSelected(o) {
      if (this.radio) {
        let { propsData } = this.radio.componentOptions,
          key = propsData.selectKey;
        return this.selected == (key ? o[key] : o);
      }
    },
    select(o) {
      if (this.radio) {
        let { listeners, propsData } = this.radio.componentOptions,
          key = propsData.selectKey;
        this.selected = key ? o[key] : o;
        listeners.input(key ? o[key] : o);
        if ("change-item" in listeners) listeners["change-item"](o);
      }
    }
  },
  created() {
    if (this.checkbox) {
      this.selected.push(...this.checkbox.componentOptions.propsData.value);
    } else if (this.radio) {
      this.selected = this.radio.componentOptions.propsData.value;
    }
  },
  mounted() {
    if (this.checkbox) {
      let { all, items } = this.$refs,
        { listeners, propsData } = this.checkbox.componentOptions,
        key = propsData.selectKey;
      items.forEach(item =>
        item.$on("change", e => {
          listeners.input(this.selected.map(o => (key ? o[key] : o)));
          if ("change-item" in listeners) listeners["change-item"](e);
        })
      );
      all.$on("change", listeners["change-all"]);
      all.relate(items);
    }
  }
};
</script>

<style lang="less">
.v-table {
  text-align: left;
  border-collapse: collapse;
  > .v-table-head > .v-table-select,
  > .v-table-body > .v-table-row > .v-table-select {
    text-align: center;
  }
  > .v-table-head > th {
    background-color: #f8f8f8;
  }
  > .v-table-body > .v-table-row {
    &:hover {
      background-color: #f4f4f4;
    }
    &.active {
      color: #ffffff;
      background-color: #41b883;
    }
  }
  &[stripe] {
    > .v-table-body {
      > .v-table-row {
        &:nth-child(even) {
          background-color: #f8f8f8;
        }
        &:hover {
          background-color: #f4f4f4;
        }
      }
    }
  }
  &[border] {
    .v-table-head > th,
    .v-table-row > td {
      border: 1px solid #cccccc;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/vue-ext/components/table/index.vue